// extracted by mini-css-extract-plugin
export default {"title":"SmBOIr8TApsoybFkANEp"};